import { getStackFromUrl, keywordsObject } from "@quickpoint.me/shared";
import { selector } from "recoil";
import { viewerHistory } from "../functionalComponents/QpHistory";
import { NumberOfPages, ParsedCode } from "./selectors";
import { IsInAuthor } from "./ui";

export function initBrowserHistory(stackCfKey: string, pageIndex: number, readMode: boolean,) {
    if (!stackCfKey) return;
    const url = readMode
        ? `/${stackCfKey}/READ/PAGE/${pageIndex}`
        : `/${stackCfKey}/PAGE/${pageIndex}`;

    viewerHistory.replace({ pathname: url, search: "" });
}

// The initial PageIndex, derived from the URL. Pure — the "resume where you
// left off?" prompts live in QpHistory so they run after first paint, not
// inside a selector evaluation.
export const getPageNumberFromUrl = selector<number>({
    key: "VS_GetPageNumberFromUrl",
    get: ({ get }) => {
        if (get(IsInAuthor)) return 1;
        const parsedCode = get(ParsedCode);
        for (const [_idx, page] of parsedCode.entries()) {
            for (const line of page) {
                if (line.type === keywordsObject["moveBy:"].keyword && line.content !== "tap") return 1
            }
        }

        const numberOfPages = get(NumberOfPages)
        if (numberOfPages === 1) return 1;

        const stackInfo = getStackFromUrl(window.location.pathname);
        if (!stackInfo.validStackCfKey) return 1;

        let pageIdx = stackInfo.page ? stackInfo.page : 1
        if (pageIdx > numberOfPages) pageIdx = numberOfPages;
        if (pageIdx < 1) pageIdx = 1;
        return pageIdx;
    },
})
